import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  Box,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import DynamicTable from "../../../Common/DynamicTable";
import { validateTable } from "../../../../utils/validateTable";
import { get, put } from "../../../../utils/api";
import style from "../../../../styles/brsr/general.module.css";
import InputField from "../../../Masters/InputField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import { restructureData } from "../../../../utils/restructureData";
import { useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const EssentialIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();

  const [tables, setTables] = useState([
    {
      fieldName: "antiCompetitiveConduct",
      rows: [
        {
          name: "",
          briefCase: "",
          correctiveActions: "",
        },
      ],
    },
  ]);
  const [errors, setErrors] = useState({});
  const [tableErrors, setTableErrors] = useState({});
  const [errorsNumber, setErrorsNumber] = useState("");
  const [listOf10TradeandIndustry, setListOf10TradeandIndustry] = useState({});
  const [islist10Trades, setListOf10Trades] = useState(false);
  const [modalupload, setModalUpload] = useState({
    numberOfAffiliationsWithTradeDoc: false,
    antiCompetitiveConductDoc: false,
  });

  const [listOf10TradeandIndustryMessage, setListOf10TradeandIndustryMessage] =
    useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [fromValues, setFromValue] = useState({
    essentialIndicators: {
      numberOfAffiliationsWithTrade: "",
      listOf10TradeandIndustry: listOf10TradeandIndustryMessage,
      antiCompetitiveConduct: tables,
      numberOfAffiliationsWithTradeDoc: [],
      antiCompetitiveConductDoc: [],
    },
  });

  const heading = [
    { title: "S. No", width: "1rem" },
    {
      title: "Name of the trade and industry chambers / associations",
      key: "name",
    },
    {
      title:
        "Reach of trade and industry chambers / associations (State/National)",
      key: "reach",
    },
  ];

  const inputData = [
    {
      fieldName: "antiCompetitiveConduct",
      title:
        "2. Provide details of corrective action taken or underway on any issues related to anti- competitive conduct by the entity, based on adverse orders from regulatory authorities.",
      type: "array",
      fields: [
        {
          fieldName: "name",
          title: "Name of authority",
          placeholder: "Type Here",
          type: "text",
          width: "15rem",
        },
        {
          fieldName: "briefCase",
          title: "Brief of the case",
          placeholder: "Type Here",
          type: "text",
          width: "15rem",
        },
        {
          fieldName: "correctiveActions",
          title: "Corrective action taken",
          placeholder: "Type Here",
          type: "text",
          width: "15rem",
        },
      ],
    },
  ];

  const [data, setData] = useState({});
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(
        `/brsr/get?subType=principle7&type=SectionC&id=${id}`
      );
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);

      const res1 =
        res?.data?.data?.BRSRSectionC?.principle7?.essentialIndicators;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFromValue({
      essentialIndicators: {
        numberOfAffiliationsWithTrade:
          data?.numberOfAffiliationsWithTrade ?? "",
        listOf10TradeandIndustry: data?.listOf10TradeandIndustry ?? "",
        numberOfAffiliationsWithTradeDoc:
          data?.numberOfAffiliationsWithTradeDoc ?? [],
        antiCompetitiveConductDoc: data?.antiCompetitiveConductDoc ?? [],
      },
    });
  }, [data]);

  
  const validateFields = () => {
    const newErrors = {};
    const missingRows = [];
    
    // Get the number of affiliations from the form
    const numberOfAffiliations = parseInt(fromValues?.essentialIndicators?.numberOfAffiliationsWithTrade) || 0;
    
    // Validate only the required number of rows based on the number of affiliations (max 10)
    const rowsToValidate = Math.min(10, Math.max(1, numberOfAffiliations));
    for (let i = 1; i <= rowsToValidate; i++) {
      const row =
        fromValues?.essentialIndicators?.listOf10TradeandIndustry?.[i - 1];

      if (!row || !row.name.trim() || !row.reach.trim()) {
        missingRows.push(i);
        newErrors[
          `row${i}`
        ] = `Row ${i}: Name of authority and Reach of authority are required`;
      }
    }

    console.log(newErrors, "errors");
    // Update the error state
    setTableErrors(newErrors);

    // Show missing rows in UI
    setListOf10Trades(missingRows.length > 0);

    return Object.keys(newErrors)?.length === 0;
  };

  const handleChangeText = (e) => {
    const { name, value } = e.target;
    // const isNumber = /^[0-9]*$/.test(value);

    const isNumber = /^\d*$/.test(value);
    // Check if the value is a number (optional: you can allow decimals if needed)

    if (!isNumber) {
      return;
    } else {
      // Clear number field error when user starts typing
      setErrorsNumber("");
      
      // Clear all table errors when number of affiliations changes
      setTableErrors({});
      
      // Only update the state if the value is a number
      // Allow empty input (for case when user deletes the value)
      setFromValue((prev) => {
        return {
          ...prev,
          essentialIndicators: {
            ...prev.essentialIndicators, // Retain previous values in essentialIndicators
            [name]: value, // Update the value for the specific key
            // listOf10TradeandIndustry: listOf10TradeandIndustry, // Retain other parts of the state
            // antiCompetitiveConduct: tables,
          },
        };
      });
    }
  };

  const handleChange = (e) => {
    // Get the value and name from the input field
    const { value, name } = e.target;

    // Set interaction flag when user starts typing
    setHasInteracted(true);

    // Split the name attribute into rowIndex and field name (e.g., "1.name" => rowIndex: 1, key: "name")
    const [rowIndexStr, key] = name.split(".");
    const rowIndex = parseInt(rowIndexStr, 10) - 1; // Convert rowIndex to zero-based index

    // Clear validation error for this specific field when user starts typing
    if (errors[rowIndexStr]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[rowIndexStr];
        return newErrors;
      });
    }

    // Clear table errors for this specific row when user starts typing
    if (tableErrors[`row${rowIndex + 1}`]) {
      setTableErrors((prev) => {
        const newTableErrors = { ...prev };
        delete newTableErrors[`row${rowIndex + 1}`];
        return newTableErrors;
      });
    }

    // Copy the current message list to preserve immutability
    const newMessageList = [
      ...fromValues?.essentialIndicators?.listOf10TradeandIndustry,
    ];

    // Ensure the row exists in the message list
    if (!newMessageList[rowIndex]) {
      newMessageList[rowIndex] = {
        rowNumber: rowIndex + 1,
        name: "",
        reach: "",
        errors: {}, // Initialize error structure
      };
    }

    // Update the specific key (e.g., "reach") in the row
    newMessageList[rowIndex][key] = value;

    // Update the message list state
    // setListOf10TradeandIndustryMessage(newMessageList);

    setFromValue((prev) => {
      return {
        ...prev,
        essentialIndicators: {
          ...prev.essentialIndicators, // Retain previous values in essentialIndicators
          // Update the value for the specific key
          listOf10TradeandIndustry: newMessageList, // Retain other parts of the state
        },
      };
    });

    // Check if both fields in the row are filled, then clear the row error
    const currentRow = newMessageList[rowIndex];
    if (currentRow && currentRow.name.trim() && currentRow.reach.trim()) {
      setTableErrors((prev) => {
        const newTableErrors = { ...prev };
        delete newTableErrors[`row${rowIndex + 1}`];
        return newTableErrors;
      });
    }

    // Validation and error handling for the corresponding row in `listOf10TradeandIndustry`
    console.log(tableErrors, "tab1", key);
    const newErrors = { ...tableErrors[rowIndex] };
    const currentValue = newMessageList[rowIndex][key];

    // If the value exists in `listOf10TradeandIndustryMessage`, update errors in `listOf10TradeandIndustry`
    if (currentValue.trim() === "") {
      newErrors[key] = `${key} is required in Row ${rowIndex + 1}`;
    } else {
      delete newErrors[key]; // Remove error if field is not empty
    }

    // Ensure listOf10TradeandIndustry has corresponding row
    const newList = { ...listOf10TradeandIndustry };
    if (!newList[rowIndexStr]) {
      newList[rowIndexStr] = {
        rowNumber: rowIndex + 1,
        name: "",
        reach: "",
        errors: {}, // Initialize error structure
      };
    }

    // Update the error state of `listOf10TradeandIndustry` if the value exists in `listOf10TradeandIndustryMessage`
    newList[rowIndexStr].errors = newErrors;

    // Remove the row's error entry in `listOf10TradeandIndustry` if no errors exist
    if (Object.keys(newErrors).length === 0) {
      delete newList[rowIndexStr].errors;
    }

    // If the value is non-empty, remove the row from `listOf10TradeandIndustry`
    if (currentValue.trim() !== "") {
      delete newList[rowIndexStr]; // Remove the row
    }

    // Update the state with the modified list
    setFromValue((prev) => {
      return {
        ...prev,
        essentialIndicators: {
          ...prev.essentialIndicators, // Retain previous values in essentialIndicators
          // Update the value for the specific key
          listOf10TradeandIndustry: newMessageList, // Retain other parts of the state
        },
      };
    });
  };

  const validateForm = () => {
    if (
      fromValues.essentialIndicators?.numberOfAffiliationsWithTrade === "" ||
      !validateNumber(
        fromValues.essentialIndicators?.numberOfAffiliationsWithTrade
      )
    ) {
      setErrorsNumber(numberError);
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // Set interaction flag to show validation errors on submit
      setHasInteracted(true);

      let v1 = validateForm();
      let v2 = validateFields();
      let v3 = validateTable(inputData, tables, setErrors);

      if (!v1 || !v2 || !v3) return;

      // Get the number of affiliations and trim the list accordingly
      const numberOfAffiliations = parseInt(fromValues?.essentialIndicators?.numberOfAffiliationsWithTrade) || 0;
      const trimmedList = (fromValues?.essentialIndicators?.listOf10TradeandIndustry || []).slice(0, numberOfAffiliations);

      let transformedData = {
        essentialIndicators: {
          numberOfAffiliationsWithTrade:
            fromValues?.essentialIndicators?.numberOfAffiliationsWithTrade,
          listOf10TradeandIndustry: trimmedList,
          ...restructureData(tables),
        },
        essentialIndicatorsSubmitted: true,
        type: "SectionC",
        subType: "principle7",
      };

      await put(`/brsr/update?id=${id}`, transformedData)
        .then((res) => onSave())
        .catch((err) => {});
    } else onSave();
  };

  return (
    <div>
      <p className={style.subHeading}>I. ESSENTIAL INDICATOR</p>

      <Typography variant="subtitle1" sx={{ fontWeight: "bold", my: "1rem" }}>
        1. (a) Number of affiliations with trade and industry chambers/
        associations.
      </Typography>
      <Box sx={{ width: "30%", ml: 2.5 }}>
        <InputField
          disabled={disabled}
          placeholder="Enter Number"
          fieldName="numberOfAffiliationsWithTrade"
          value={fromValues.essentialIndicators?.numberOfAffiliationsWithTrade}
          handleChange={(e) => {
            handleChangeText(e);
            setErrorsNumber("");
          }}
          errors={errorsNumber}
        />
      </Box>

     
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "bold",
          my: "1rem",
          textIndent: "-1.2rem",
          ml: "1.2rem",
        }}
      >
        1. (b) List the top 10 trade and industry chambers/ associations
        (determined based on the total members of such body) the entity is a
        member of / affiliated to.
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          ml: 2.5,
          width: "97.5%",
        }}
      >
        {" "}
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "9% 47% 44%",
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                    textAlign: item?.title === "S. No" ? "center" : "left",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {[...Array(Math.min(10, Math.max(1, parseInt(fromValues?.essentialIndicators?.numberOfAffiliationsWithTrade) || 1)))].map((_, index) => {
            // Generates numbers 1 to the number of affiliations
            const rowNumber = index + 1; // Convert 0-based index to 1-based numbering
            const isTotalRow = false; // Modify this logic if needed
            return (
              <Box
                key={rowNumber}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "9% 47% 44%",
                  borderBottom: "1px solid #ddd",
                  justifyContent: "center",
                }}
              >
                {/* Row Number */}
                <Typography
                  sx={{
                    borderRight: "1px solid #DBDBDB",
                    fontSize: "15px",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {rowNumber}.
                </Typography>

                {/* Map over heading for each column (excluding the first column) */}
                {heading.length > 0 &&
                  heading.slice(1).map((headings, colIndex) => {
                    const name = `${rowNumber}.${headings.key}`;

                    return (
                      <TextField
                        disabled={disabled}
                        key={colIndex} // Key for each column
                        variant="standard"
                        multiline
                        minRows={1}
                        sx={{
                          backgroundColor: isTotalRow ? "#EFEFEF" : "",
                          borderRight: "1px solid #DBDBDB",
                          padding: "8px 12px",
                          "& .MuiInputBase-root": {
                            padding: 0, // Align with grid cells
                          },
                        }}
                        name={name}
                        type="text"
                        InputProps={{ disableUnderline: true }}
                        fullWidth
                        size="small"
                        // value={listOf10TradeandIndustryMessage[index]?.reach || ""}
                        value={
                          fromValues?.essentialIndicators
                            ?.listOf10TradeandIndustry?.[index]?.[
                            headings.key
                          ] || ""
                        }
                        placeholder="Enter Text"
                        onChange={(e) => handleChange(e, index, "reach")}
                      
                      />
                    );
                  })}
              </Box>
            );
          })}
        </Box>
      </TableContainer>
     
      {Object.keys(tableErrors)?.length > 0 && (
        <div
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
            marginLeft: "1.6rem",
            marginTop: "0.5rem",
          }}
        >
          {Object.values(tableErrors).map((error, index) => (
            <p
              key={index}
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {error}
            </p>
          ))}
        </div>
      )}

      {/* )} */}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: fromValues,
          setFormData: setFromValue,
          errors,
          setErrors,
          Uploadkey: "numberOfAffiliationsWithTradeDoc",
          ml: 3,
          removeUpload,
        }}
      />
      <DynamicTable
        {...{
          inputData,
          handleSubmit,
          tables,
          setTables,
          errors,
          setErrors,
          data,
          disabled,
          hide,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: fromValues,
          setFormData: setFromValue,
          errors,
          setErrors,
          Uploadkey: "antiCompetitiveConductDoc",
          ml: 3,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98.5%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default EssentialIndicator;
